import lazySizes from "lazysizes";

function init() {
  lazySizes.cfg.loadMode = 1;
  lazySizes.cfg.expand = 300;
}

export { init };
